/**
 * Модуль для коррекции размер изображений с учтом пропорций
 *
 */
( function(global) {
    'use strict';

    document.addEventListener('DOMContentLoaded', () => {
        fixSizeImages(document.querySelectorAll('img#preview_image'));
    });


    /**
     * Производит корректировку размера указанных изображений
     *
     * @param {NodeList} images
     */
    function fixSizeImages(images) {
        if (!images) {
            return;
        }

        [].forEach.call(images, (image) => {
            fixSizeImage(image);
        })
    }

    /**
     * Производит корректировку размера указанного изображения
     *
     * @param {Node} image
     */
    function fixSizeImage(image) {
        if (image.hasAttribute('style')) {
            return;
        }

        setSize(image);
    }

    function setSize(img) {
        let maxSize = getMaxSize();
        let percent;
        let width = maxSize.width;
        let height = maxSize.height;
        let naturalWidth = parseInt(img.getAttribute('width-fact'), 10);
        let naturalHeight = parseInt(img.getAttribute('height-fact'), 10);

        console.log('maxSize', maxSize);
        console.log('naturalWidth', naturalWidth);
        console.log('naturalHeight', naturalHeight);

        if (isSetObjectFit(img)) {
            img.style.maxWidth = naturalWidth + 'px';
            img.style.maxHeight = naturalHeight + 'px';
            return;
        }

        if (naturalWidth > maxSize.width) {
            width = maxSize.width;

            percent = ((width * 100) / naturalWidth);
            height = Math.ceil((percent * naturalHeight) / 100);
        } else if (naturalHeight > maxSize.height) {
            height = maxSize.height;

            percent = (height * 100) / naturalHeight;
            width = Math.ceil((percent * naturalWidth) / 100);
        } else {
            width = naturalWidth;
            height = naturalHeight;
        }

        img.style.width = width + 'px';
        img.style.height = height + 'px';
    }

    /**
     * Возвращает максимально возможный размер для изображения
     *
     * @return {Object}
     */
    function getMaxSize() {
        let element = document.querySelector('.page-field');

        return {
            width: parseInt(element.clientWidth, 10) * 0.9, //90% от ширины,
            height: parseInt(window.innerHeight, 10) * 0.9 //90% от высоты
        }
    }

    function isSetObjectFit(image) {
        console.log('image', image);
        console.log('object-fit', getComputedStyle(image)['object-fit']);

        return !!getComputedStyle(image)['object-fit'];
    }

}(window));